<template>
  <div class="contain dom-page">
    <h2>{{ $t('배달앱 옵션 연결') }}</h2>
    <el-form v-if="!isStoreAccount" inline @submit.native.prevent="selectStore">
      <el-form-item :label="$t('매장 코드')">
        <el-input-number v-model="storeInput" :min="1" :precision="0" :controls="false" :disabled="busy" />
      </el-form-item>
      <el-form-item>
        <el-button native-type="submit" :disabled="busy || !storeInput">{{ $t('조회') }}</el-button>
      </el-form-item>
    </el-form>
    <p>{{ $t('대상 매장') }}: {{ scopeStoreName(storeCd) }}</p>
    <delivery-option-mapping-panel
      v-if="storeCd"
      :key="storeCd"
      :store-cd="storeCd"
      :initial-smenu-cd="smenuCd"
      :initial-option-cd="optionCd"
      @busy="busy = $event" />
    <el-alert
      v-else
      type="info"
      :closable="false"
      :title="$t('대상 매장을 먼저 선택해 주세요. 메뉴 연결이나 품절 관리에서도 옵션 연결을 열 수 있습니다.')" />
  </div>
</template>
<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import deliveryMenuScopeMixin from '@/mixins/deliveryMenuScopeMixin'
import { parseStoreCd } from '@/utils/posDeliverySoldout'
import DeliveryOptionMappingPanel from '@/components/deliveryMenu/DeliveryOptionMappingPanel.vue'

export default {
  name: 'DeliveryOptionMappingView',
  mixins: [mainVueMixin, deliveryMenuScopeMixin],
  components: { DeliveryOptionMappingPanel },
  data() {
    return { busy: false, storeInput: parseStoreCd(this.$route.query.storeCd) }
  },
  computed: {
    isStoreAccount() {
      return this.$store.getters['auth/authId'] === 'storeMng'
    },
    storeCd() {
      return this.$route.query.storeCd != null ? parseStoreCd(this.$route.query.storeCd) : this.scopeStoreCd
    },
    smenuCd() {
      return parseStoreCd(this.$route.query.smenuCd)
    },
    optionCd() {
      return parseStoreCd(this.$route.query.smenuOptCd)
    },
  },
  created() {
    if (this.isStoreAccount) this.loadScopeStore()
  },
  watch: {
    storeCd(value) {
      this.storeInput = value
    },
  },
  methods: {
    selectStore() {
      const storeCd = parseStoreCd(this.storeInput)
      if (this.busy || storeCd == null || storeCd === this.storeCd) return
      this.$router.replace({ query: { storeCd: String(storeCd) } }).catch(() => {})
    },
  },
  beforeRouteLeave(to, from, next) {
    next(!this.busy)
  },
  beforeRouteUpdate(to, from, next) {
    next(!this.busy)
  },
}
</script>
<style scoped>
.dom-page {
  padding: 16px;
  overflow: auto;
}
.dom-page h2 {
  margin-top: 0;
  font-size: 20px;
}
</style>
